/**
 * Chat id contract for file uploads (PWI-420, related to agent-platform#610).
 *
 * The platform's file upload endpoint accepts an empty or absent chat id and
 * treats it as a knowledge hub upload. That meaning is reserved for the
 * knowledge hub (Filedrop), which deliberately sends an empty chat id.
 *
 * Every chat upload must carry the id of the chat it belongs to. A chat upload
 * that lost its id would no longer be rejected by the API and would be stored
 * as a private knowledge hub document that chat-scoped retrieval never finds,
 * so chat upload paths call this helper to fail in the frontend instead.
 *
 * @param chatId - The chat id a chat upload is about to be sent with.
 * @returns The chat id unchanged, so the uploaded id always matches the run id
 * exactly. Whitespace only matters for deciding whether an id is present.
 * @throws Error when the id is missing, empty or only whitespace.
 */
export const requireChatId = (chatId: string | null | undefined): string => {
  if (!chatId?.trim()) {
    throw new Error("A chat id is required to upload a file to a chat");
  }

  return chatId;
};
